<span class="sr-only">{{
    'AI.ACCESSIBILITY.MESSAGE_FROM_USER' | translate
}}</span>
@if (message().attachment; as attachment) {
    <interacta-ai-shared-attachment-chip
        class="mb-8 ml-auto block w-fit max-w-full"
        [attachment]="attachment.attachmentData"
        [unavailableLabel]="attachment | apply: getReferenceUnavailableLabel"
        (attachmentClick)="openAttachment(attachment)"
    />
}
@if (message().reference; as reference) {
    <interacta-ai-shared-reference-chip
        class="mb-8 ml-auto block w-fit max-w-full"
        [reference]="reference"
        (referenceClick)="openReference(reference)"
    />
}
<section
    class="ml-auto block w-fit max-w-2/3 rounded-2xl rounded-br-none bg-surface-chat-A px-12 py-8 shadow-chat"
>
    <p class="typo-sm wrap-break-word">
        {{ message().content }}
    </p>
</section>
